import { useQuery } from "@rocicorp/zero/react"
import { IconCheckOutline18 as Check } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/browser"
import { CommandItem } from "@productlane/ui/src/components/internal/command"
import { queries } from "@productlane/zero/queries"

import type { SharedFilterItemsProps } from "./types"
import { useThreadsFilterState } from "../threads-filter-state"

export function CreatorFilterItems({ onSelect }: SharedFilterItemsProps) {
	const { creatorIds, addCreator, removeCreator } = useThreadsFilterState()
	const [users] = useQuery(queries.users())

	return (
		<>
			{users.map((user) => (
				<CommandItem
					onSelect={() => {
						if (creatorIds.includes(user.id)) {
							removeCreator(user.id)
						} else {
							addCreator(user.id)
						}
						onSelect()
					}}
					key={user.id}
				>
					<div className="flex w-full items-center gap-2">
						<span className="flex-1 truncate">{user.name}</span>
						<Check
							className={cn("h-4 w-4 shrink-0", {
								"opacity-100": creatorIds.includes(user.id),
								"opacity-0": !creatorIds.includes(user.id),
							})}
						/>
					</div>
				</CommandItem>
			))}
		</>
	)
}
